<template>
<div>
  <request-status
    :request='appointmentRequest'
    message404='Unable to load appointment. You may not have sufficient permissions to view this appointment' />
  <transition name='fade'>
  <v-toolbar dense >
    <v-btn
      :loading='appointmentRequest.loading'
      @click='loadAppointment' small icon >
      <v-icon small >replay</v-icon>
    </v-btn>
    <v-divider vertical ></v-divider>
    <v-toolbar-title v-if='!editTitle' >
      <v-icon v-if='appointment.is_online' >headset_mic</v-icon>
      <span v-if='appointment.title' >{{appointment.title}}</span>
      <span v-else >{{appointment.full_name}}</span>
      <v-btn @click='editTitle=true' icon><v-icon small dark >edit</v-icon></v-btn>

    </v-toolbar-title>
    <v-text-field v-else dense class='ml-0 mt-3'
      v-model='appointment.title'
      @click:append='savetitle(appointment.title)'
      @click:append-outer='editTitle = false'
      :loading='editAppointmentRequest.loading'
      append-icon='save'
      append-outer-icon='cancel'
      label='Appointment title' >
    </v-text-field>
    <v-spacer></v-spacer>
    <v-chip label small v-if='appointment.is_online' outline color='primary' >
      Online
    </v-chip>
    <v-chip label small dark v-if='appointment.source && appointment.source.startsWith("online-booking")'
      color='success' >
      Booked online
    </v-chip>
    <v-chip label small dark v-if='appointment.status'
      :class='formatStatus(appointment.status).theme' >
      {{formatStatus(appointment.status).title}}
    </v-chip>
    <!-- <v-btn small >
      Show
      <v-icon small >open_in_new</v-icon>
    </v-btn> -->
    <action-menu :appointment='appointment' :exclude='["open_appointment"]' ></action-menu>

  </v-toolbar>
  </transition>

  <!-- style='border-left: solid 5px red;'  -->
  <v-card flat >
    <template v-if='appointment && appointment.id' >
      <flexible-component-container
        :items='items'
        :isCompact='isCompact' >
      </flexible-component-container>
    </template>
  </v-card>

  <v-divider/>
  <v-footer class='caption pl-3' >
    #{{appointment.id}}.
    Created: {{dateformat(appointment.created_date, 'ddd DD MMM YYYY \\at HH:mm')}}.
    Source: {{appointment.source}}
  </v-footer>

</div>

</template>
<script type="text/javascript">
// import CommunicationTemplateList from '@/components/lists/CommunicationTemplateList'

// import ClientPicker from '@/components/pickers/ClientPicker'
import ActionMenu from '@/components/appointment/actions/ActionMenu'
import RequestMixin from '@/mixins/requests'
import FlexibleComponentContainer from '@/components/ui/FlexibleComponentContainer'

// tabs/panels:
import AppointmentCard from '@/components/cards/AppointmentCard'
import NotesTab from './detail/NotesTab'
import NotificationsTab from './detail/NotificationsTab'
import InvoiceDetails from '@/components/appointment/edit/InvoiceDetails'
import {ACTIVE_APPOINTMENT_DETAIL} from '@/store/constants'

export default {
  name: 'AppointmentDetail',
  mixins: [RequestMixin],
  components: {
    FlexibleComponentContainer,
    ActionMenu
  },
  props: {
    initialAppointment: { type: Object, default: () => { return {} } },
    appointmentId: { default: null },
    isCompact: { type: Boolean, default: false }
  },
  data () {
    return {
      appointment: {},
      editReqId: 'appointment-edit',
      processReqId: 'appointment-process',
      editTitle: false,
      edits: [
        {title: 'Invoice details'},
        {title: 'Notes'},
        {title: 'Reschedule'},
        {title: 'Change customer'}
      ],
      actions: [
        {title: 'Send payment reminder'},
        {title: 'Mark as paid'},
        {title: 'Mark as done'}
      ],
      dangerActions: [
        {title: 'Cancel'}
      ]
    }
  },
  mounted () {
    if (this.initalAppointment) {
      this.appointment = this.initalAppointment
    }
    this.loadAppointment()
  },
  watch: {
    appointmentId () {
      if (this.appointmentId) {
        this.loadAppointment()
      }
    },
    initialAppointment () {
      if (this.initalAppointment) {
        this.appointment = this.initalAppointment
      }
    },
    appointmentRequestStatus () {
      if (this.appointmentRequestStatus === 200) {
        this.appointment = this.appointmentRequest.result.data
      }
    },
    editAppointmentRequestStatus () {
      if (this.editAppointmentRequestStatus === 200) {
        this.appointment = this.appointmentRequest.result.data
        this.editTitle = false
      }
    }
    // routeId () {
    //   this.getAppointment()
    // }
  },
  computed: {
    routeId () {
      if (this.$route.params) {
        return this.$route.params.id
      }
    },
    items () {
      return [
        {
          id: 'AppointmentHomepage',
          title: 'Appointment details',
          component: AppointmentCard,
          attrs: {
            value: this.appointment
          }
        },
        {
          id: 'AppointmentNotifications',
          title: 'Notifications',
          component: NotificationsTab,
          attrs: {
            value: this.appointment
          }
        },
        {
          id: 'AppointmentNotes',
          title: 'Notes',
          component: NotesTab,
          attrs: {
            value: this.appointment
          }
        },
        {
          id: 'AppointmentInvoiceDetails',
          title: 'Invoice details',
          component: InvoiceDetails,
          attrs: {
            value: this.appointment,
            deletable: true,
            withDone: false
          }
        }
      ]
    },
    appointmentRequest () {
      return this.$store.getters.getRequestById(ACTIVE_APPOINTMENT_DETAIL, true)
    },
    appointmentRequestStatus () {
      return this.appointmentRequest.status
    },
    editAppointmentRequest () {
      return this.$store.getters.getRequestById(this.editReqId, true)
    },
    editAppointmentRequestStatus () {
      return this.editAppointmentRequest.status
    }
  },
  methods: {
    // createProcess (name, appointment, payload = {}) {
    //   let processId = `schedule.models.AppointmentProcess.${name}`
    //   this.performProcess(
    //     this.processReqId,
    //     processId,
    //     this.$store.getters.me.id,
    //     appointment.id,
    //     payload)
    // },
    savetitle (title) {
      // let dt = this.dateformat(this.appointment.start_time, 'ddd DD MM YYYY')
      let data = {
        title: title
        // full_name: title,
        // invoice_title: `${title}, ${dt}`
      }
      this.updateAppointment(data)
    },
    updateAppointment (data) {
      this.$appointmentguru
          .resource('appointment')
          .id(this.editReqId)
          .save(this.appointmentId, JSON.stringify(data))
    },
    loadAppointment () {
      let vm = this
      vm.getAppointment(vm.appointmentId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// AppointmentDetail.vue?40a388d6